export const SAVE_CATEGORY_ANALYTICS = 'SAVE_CATEGORY_ANALYTICS';
export const SAVE_ITEMS_ANALYTICS = 'SAVE_ITEMS_ANALYTICS';
export const ITEMS_ANALYTICS_FOR = 'ITEMS_ANALYTICS_FOR';
export const SAVE_ITEM_COUNT = 'SAVE_ITEM_COUNT';
